export default `.ids-upload {
  --ids-input-padding-inline-end: 0;
  position: relative;
}
.ids-upload .ids-upload-filetype {
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: -webkit-fill-available;
  z-index: -1;
}

ids-trigger-field::part(clearable-button) {
  margin-inline-end: -6px;
}

:host([compact]) ids-trigger-field::part(clearable-button),
.ids-upload-compact ids-trigger-field::part(clearable-button) {
  margin-inline-end: 1px;
  height: 22px;
  width: 22px;
}

:host([label-position=inline-start]) ids-trigger-field::part(label) {
  white-space: nowrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdXBsb2FkIiwic291cmNlcyI6WyJpZHMtdXBsb2FkLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUVBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFJSjtFQUNFOzs7QUFHRjtBQUFBO0VBRUU7RUFDQTtFQUNBOzs7QUFJQTtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLmlkcy11cGxvYWQge1xuICAtLWlkcy1pbnB1dC1wYWRkaW5nLWlubGluZS1lbmQ6IDA7XG5cbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gIC5pZHMtdXBsb2FkLWZpbGV0eXBlIHtcbiAgICBvcGFjaXR5OiAwO1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDUwJTtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTUwJSk7XG4gICAgd2lkdGg6IC13ZWJraXQtZmlsbC1hdmFpbGFibGU7IC8vIHN0eWxlbGludC1kaXNhYmxlLWxpbmVcbiAgICB6LWluZGV4OiAtMTtcbiAgfVxufVxuXG5pZHMtdHJpZ2dlci1maWVsZDo6cGFydChjbGVhcmFibGUtYnV0dG9uKSB7XG4gIG1hcmdpbi1pbmxpbmUtZW5kOiAtNnB4O1xufVxuXG46aG9zdChbY29tcGFjdF0pIGlkcy10cmlnZ2VyLWZpZWxkOjpwYXJ0KGNsZWFyYWJsZS1idXR0b24pLFxuLmlkcy11cGxvYWQtY29tcGFjdCBpZHMtdHJpZ2dlci1maWVsZDo6cGFydChjbGVhcmFibGUtYnV0dG9uKSB7XG4gIG1hcmdpbi1pbmxpbmUtZW5kOiAxcHg7XG4gIGhlaWdodDogMjJweDtcbiAgd2lkdGg6IDIycHg7XG59XG5cbjpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLXN0YXJ0J10pIHtcbiAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQobGFiZWwpIHtcbiAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICB9XG59Il19 */`;
